<template>
    <div class="page flex">
		<div class="foot_1 flex align-content justify-content align-items">
			<img class="foot_1_1" src="../../static/image/2.png" alt="" srcset="">
			<div class="foot_1_2">哈斯医疗</div>
		</div>
		<div class="w1200 flex foot_4">
			<!--  -->
			<div class="flex" v-if="myInfo">
				<template v-for="(item,index) in tab_let">
					<div class="flex align-content justify-content align-items pointer" @click="tiaozhuan(item)" :class="tap_type != item.id ? 'foot_2' : 'foot_3'" v-if="id_list.indexOf(item.id) != -1" >
						<p class="foot_2_1" >{{item.name}}</p>
						<img class="foot_2_2" v-if="tap_type != item.id" src="../../static/image/13.png" alt="" srcset="" @click="shanchu(item)">
						<img class="foot_2_2" v-else src="../../static/image/14.png" alt="" srcset="" @click="shanchu(item)">
					</div>
				</template>
			</div>
			<div class="flex benben-flex-layout flex-wrap align-center pointer foot_8" @click="tiuan">
				<img class="foot_6" :src="user_info.avatar" alt="" srcset="">
				<div class="foot_7">{{user_info.nickname}}</div>
			</div>
			<div class="">
				<el-popconfirm
				  title="确定要退出么？"
				  @confirm="queding"
				>
				  <el-button slot="reference" class="foot_5">
					  <div class="foot_9 pointer">退出</div>
				  </el-button>
				</el-popconfirm>
			</div>
			
			
		</div>
    </div>
</template>

<script>
  export default {
    name: 'nav-footer',
    data(){
      return{
		  tab_let:[
			  // {id:1,name:'首页',puth:'index'},
			  // {id:2,name:'学习视频',puth:''},
			  // {id:3,name:'卡片管理',puth:''},
			  // {id:4,name:'关于我们',puth:''},
			  // {id:5,name:'帮助反馈',puth:''},
			  // {id:6,name:'用户协议',puth:''},
			  // {id:7,name:'隐私政策',puth:''},
			  {id:1,name:'首页',puth:'index'},
			  {id:2,name:'学习视频',puth:'video'},
			  {id:3,name:'卡片管理',puth:'card'},
			  {id:4,name:'关于我们',puth:'aboutUs'},
			  {id:5,name:'帮助反馈',puth:'feedback'},
			  {id:6,name:'用户协议',puth:'agreement'},
			  {id:7,name:'隐私政策',puth:'privacy'},
		  ],
		  url_list : [
		  	{id:1,name:'首页',puth:'index'},
		  	{id:2,name:'学习视频',puth:'video'},
		  	{id:3,name:'卡片管理',puth:'card'},
		  	{id:4,name:'关于我们',puth:'aboutUs'},
		  	{id:5,name:'帮助反馈',puth:'feedback'},
		  	{id:6,name:'用户协议',puth:'agreement'},
		  	{id:7,name:'隐私政策',puth:'privacy'},
		  ],
		  id_list:[],
		  tap_type:'',
		  myInfo:true,
		  user_info:'',
	  }
    },
	watch: {
		//监听路由地址的改变
		$route: {
			immediate: true,
			handler() {
				if (this.$route.path == '/myInfo') {
					this.myInfo = false
				}
			}
		}
	},
    mounted() {
		document.addEventListener('fullscreenchange', this.handleFullscreenChange);
		document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
		document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
		document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
		let index = ''
		if (window.sessionStorage.getItem('statusType')) {
			index = window.sessionStorage.getItem('statusType')
			// console.log(index,111111)
			let list2 = []
			list2.push(Number(index))
			this.id_list = list2
			this.tap_type = index
		// 	let item = ''
		// 	let list0 = []
		// 	let list1 = []
		// 	for (var i = 0; i < this.url_list.length; i++) {
		// 		if(this.url_list[i].id == index){
		// 			item = this.url_list[i]
		// 		}
		// 	}
		// 	list0.push(item)
		// 	list1.push(item.id)
		// 	if(this.tab_let.length == 0){
		// 		// this.tab_let = list0
		// 		this.id_list = list1
		// 		this.tap_type = index
		// 	}
		}
    },
	created(){
			// if(window.sessionStorage.getItem('user')){
			// 	let user = window.sessionStorage.getItem('user')
			// 	this.user_info = JSON.parse(user);
			// 	// console.log(user,123)
			// }
		this.post5c78c4772da97()
	},
    methods: {
		// 获取个人资料
		post5c78c4772da97(){
			this.$api.post(this.$apiUrls.post5c78c4772da97, {}).then((res) => {
				if (res.code == 1) {
					this.user_info = res.data
				} else {
					this.$message.error(res.msg);
					return
				}
			})
		},
		queding(){
			console.log('执行主席或者')
			// window.sessionStorage.setItem('token', '');
			// window.sessionStorage.setItem('user','');
			// window.sessionStorage.setItem('statusType', 0);
			this.$router.push({
				name: 'login',
				params: {},
			});
		},
		tiaozhuan(item){
			if(item.id != this.tap_type){
				this.tap_type = item.id
				this.$router.push({
					name: item.puth,
				});
			}
		},
		tiuan(){
			this.$router.push({
				name: 'myInfo',
			});
		},
		// 左侧按钮点击
		testB(item){
			// 全屏
			// const element = document.documentElement;
			// element.requestFullscreen();
			let num = Number(item)
			let index = this.id_list.indexOf(num)
			if(index != -1){
				this.tap_type = Number(item)
			}else{
				// for (var i = 0; i < this.url_list.length; i++) {
				// 	if(num == this.url_list[i].id){
				// 		this.tab_let.push(this.url_list[i])
				// 	}
				// }
				this.id_list.push(Number(item))
				this.tap_type = Number(item)
			}
		// console.log(this.tab_let,item,index,1111111111)
		},
		shanchu(item,index){
			// 取消全屏
			// const element = document.documentElement;
			// document.exitFullscreen();
			// console.log(this.id_list,this.tab_let,this.tap_type,11111)
			if(this.id_list.length == 1){
				this.$message.error('请保留一个菜单');
				return
			}else{
				let index = this.id_list.indexOf(item.id)
				if(item.id != this.tap_type){
					this.id_list.splice(index,1)
					// this.tab_let.splice(index,1)
				}else{
					this.tap_type = this.id_list[index - 1]
					this.id_list.splice(index,1)
					// this.tab_let.splice(index,1)
					let puth = ''
					for (var i = 0; i < this.url_list.length; i++) {
						if(this.tap_type == this.url_list[i].id){
							puth = this.url_list[i].puth
						}
					}
					this.$router.push({
						name: puth,
					});
				}
			
			}
			// console.log(this.id_list,this.tap_type,22222)
			// if(index > 1)
		},
		testA(name){
			this.tobItem = this.tobList[name]
		},
		handleFullscreenChange() {
		    let  isFullscreen = !!(
		        document.fullscreenElement ||
		        document.webkitFullscreenElement ||
		        document.mozFullScreenElement ||
		        document.msFullscreenElement
		    );
			// console.log(isFullscreen,1111111111111111)
		}
    }
  }
</script>

<style lang="scss" scoped>
	::v-deep {
		.foot_5{
			padding: 0;
			margin: 0;
			border: none;
		}
		.foot_5 span{
			display: flex;
		}
		.foot_5:hover {
			background: #fff;
		}
	}
	.page{
		width: 100%;
		height: 64px;
		// background: #000;
	}
	.foot_1{
		width: 220px ;
		flex-shrink: 0;
	}
	.foot_1_1{
		width: 40px;
		height: 40px;
	}
	.foot_1_2{
		font-weight: bold;
		font-size: 26px;
		color: #004EA1;
		margin: 0 0 0 10px;
	}
	.foot_3{
		width: 106px;
		height: 44px;
		background: #004EA1;
		border-radius: 16px 16px 0 0 ;
		.foot_2_1{
			font-weight: 400;
			font-size: 14px;
			color: #FFFFFF;
		}
	}
	.foot_2{
		width: 106px;
		height: 44px;
		background: #fff;
		border-radius: 16px 16px 0 0 ;
		.foot_2_1{
			font-weight: 400;
			font-size: 14px;
			color: #999999;
		}
	}
	
	.foot_2_2{
		width: 12px;
		height: 12px;
		margin: 0 0 0 8px;
	}
	.foot_4{
		margin: 19px 0 0 0;
	}
	.foot_5{
		margin: 0 20px 0 auto;
	}
	.foot_6{
		width: 32px;
		height: 32px;
		margin: 0 16px 0 0;
	}
	.foot_8{
		margin: 0 20px 0 auto;
	}
	.foot_9{
		line-height: 45px;
	}
</style>